import React from 'react';
interface RelatedArticlesBlock {
  _template: string;
  css_class_name: string;
  settings: Settings;
  title: string;
  related_articles: string;
}

interface RelatedArticlesProp {
  block: RelatedArticlesBlock;
  data: AcademyRelatedArticle[] | undefined;
}

const RelatedArticles: React.FC<RelatedArticlesProp> = ({ block, data: relatedArticles }) => {
  if (!relatedArticles || relatedArticles.length === 0) {
    return null;
  }

  return (
    <section className={`block ${block._template} ${block.css_class_name}`}>
      <h3 className='glossary-title'>
        {block.title}
        <span className='related-articles__line'></span>
      </h3>
      <div className='glossary-item'>
        <ul className='related-articles__list'>
          {relatedArticles.map(relatedArticle => (
            <li
              className='related-articles-list__item'
              key={relatedArticle.Id}
            >
              <a
                className='link-style'
                href={relatedArticle.UrlPath}
              >
                {relatedArticle.ListTitle}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default RelatedArticles;
